export default {
  body:
    '"Poppins", system-ui, -apple-system, BlinkMacSystemFont,  Roboto, "Helvetica Neue", sans-serif',
  heading: "Work Sans",
  monospace: "Menlo, monospace",
}
